//バージョン番号に関するモジュール

import axios from "axios"

const state = {
    version: null,
}

const getters = {
    getVersion(state) {
        return state.version
    },
}

const actions = {
    async setVersion({commit}) {
        await axios
          .get('/api/version')
          .then(response => commit('setVersion', response.data))
    },
}

const mutations = {
    setVersion(state, version){
        state.version = version
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}